<template>
  <div class="addFile commonMedical" :updateFileList="updateFileList" :updatePicList="updatePicList">
    <div class="addCourseware">
      <div class="addCourseBtn">
        <p>文档类型：</p>
      </div>
      <ul class="filelist">
        <li v-for="(file,index) in FileList" @click="fileClick(index,FileList)">
          <div v-show="true">
            <div class="exapleImg hover_Img">
              <img class="example-image" :src="file.imgurl" />
            </div>
            <b>{{file.attach_name}}</b>
          </div>
        </li>
      </ul>
    </div>

    <div class="addOther">
      <div class="addCourseBtn">
        <p>其他图片：</p>
      </div>
      <ul class="filelist">
        <li v-for="(file,index) in PicList">
          <div v-show="true">
            <div class="exapleImg">
              <a class="example-image-link" :href="file.fileurl" data-lightbox="example-1"><img class="example-image" :src="file.fileurl" /></a>
            </div>
            <b>{{file.attach_name}}</b>
          </div>
        </li>
      </ul>
    </div>
    <!--文件预览-->
    <pops :show="filePop" :title="''" @closePop="closeFile" :class="'mrDialog'" :width="'980px'">
      <div class="altit">
        <p class="tip">暂不支持预览，请点击下载</p>
        <a class="downLoad" :href="url">下载</a>
      </div>
    </pops>
  </div>
</template>
<script type="text/ecmascript-6">
  import pops from '@/components/common/pops/pop'
  export default {
    name: 'accident',
    components: {
      pops
    },
    props: {
      updateFileList: {
        type: Array,
        default: () => []
      },
      updatePicList: {
        type: Array,
        default: () => []
      },
      boxName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        FileList: [],
        PicList: [],
        stopVal: 0,
        url:'',
        filePop: false,
        fileurl: '',
        fileShow: true,
        fileColse: false
      }
    },
    watch: {
     
      updateFileList (n, o) {
        this.FileList = n
       
        for (let item of n) {
          let sExt = item.attach_name.substring(item.attach_name.lastIndexOf('.') + 1)
          // console.log(sExt)
          if (sExt == 'xls') { //判断类型显示图标
            item.imgurl = './static/image/xlsicon.png'
          } else if (sExt == 'doc' || sExt == 'rtf' || sExt == 'docx' ) {
            item.imgurl = './static/image/docicon.png'
          } else if (sExt == 'pdf') {
            item.imgurl =  './static/image/pdficon.png'
          } else if (sExt == 'ppt' || sExt == 'pptx') {
            item.imgurl = './static/image/ppticon.png'
          } else {
            item.imgurl = './static/image/xlsicon.png'
          }
        }
      },
      updatePicList (n, o) {
        this.PicList = n
      }
      
    },
    mounted() {
    },
    methods: {
      layout() {
        let [width, els] = [document.getElementById(this.boxName).clientWidth - 120 + 'px', document.getElementsByClassName('filelist')]
        for (let item of els) {
          item.style.width = width
        }
      },
      fileClick(val, FileList) {
        console.log(FileList)
        this.url = encodeURI(encodeURI(FileList[val].fileurl))
     
        this.filePop = true
      },
      closeFile(payload) {
        this.filePop = payload
      },
    },
    //页面加载后执行
    mounted() {
      /*setTimeout(() => {
       this.layout();
       }, 20)*/
    },
    created() {
    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .hover_Img:hover
    cursor: pointer
  .altit
    height: 400px
    .tip
      text-align:center
      font-size:100%
      position: relative
      top: 130px
      color: #9d9ea3
    .downLoad
      display: block;
      width: 80px;
      height: 27px;
      line-height: 27px;
      cursor: pointer;
      background: #01abac;
      color: #fff;
      border-radius: 3px;
      text-align: center;
      margin: 0 auto;
      position: relative
      top: 140px
  .addFile
    .addCourseware
    .addOther
      width: 100%
      min-height: 170px
      overflow: hidden
      padding-top: 6px
      .addCourseBtn
        width: 120px
        float: left
        p
          text-align: center
          line-height: 40px
          color: #333
      ul
        float: left
        width: calc(100% - 120px)
        li
          float: left
          width: 102px
          min-height: 160px
          margin-right: 30px
          position: relative
          i
            position: absolute
            width: 12px
            height: 12px
            right: -5px
            top: -5px
            background: gray
          b
            text-align: center
            padding: 4px 0
            line-height: 24px
            width: 100px
            display: block
            word-wrap: break-word
            word-break: normal
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .exapleImg
            border: 1px solid gray
            display: flex
            justify-content:center
            align-items:center
            width: 100px
            height: 100px
            img
              max-width: 80px
              max-height: 80px
              margin: 10px auto


</style>



// WEBPACK FOOTER //
// uploadDetail.vue?1cf746f4